export default async function CascadeTopPlanApi(
  cascadeFrom,
  title,
  description,
  unitId,
  target,
  targetDate,
  assignTo,
  positionId,
  attributes,
  strategyId = null,
  ehrmEvalId,
  ehrmGoalTypeId,
  ehrmGoalWeightage,
  cascadeFromSplitPlans = false,
  isPercentageUpdate = false,
  isNegativeScale = false
) {
  let res = "";
  try {
    const body = {
      cascadeFrom: cascadeFrom,
      title: title,
      description: description,
      unitId: unitId,
      target: target,
      targetDate: targetDate,
      assignTo: assignTo,
      positionId: positionId,
      attributes: attributes,
      strategyId: strategyId,
    };

    // Only add EHRM fields if they have values
    if (ehrmEvalId !== undefined) {
      body.ehrmEvalId = ehrmEvalId;
    }
    if (ehrmGoalTypeId !== undefined) {
      body.ehrmGoalTypeId = ehrmGoalTypeId;
    }
    if (ehrmGoalWeightage !== undefined) {
      body.ehrmGoalWeightage = ehrmGoalWeightage;
    }

    // Add cascade from split plans flag
    body.cascadeFromSplitPlans = cascadeFromSplitPlans;

    // Add percentage update fields
    if (isPercentageUpdate !== undefined) {
      body.isPercentageUpdate = isPercentageUpdate;
    }

    // Add negative scale field
    if (isNegativeScale !== undefined) {
      body.isNegativeScale = isNegativeScale;
    }

    console.log('CascadeTopPlanApi - Request Body:', JSON.stringify(body, null, 2));
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/cascade-top-plans`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
